import React from 'react';
import TextInput from "@/Shared/TextInput";
import TextArea from "@/Shared/TextArea";
import CustomCheckbox from "@/Shared/CustomCheckbox";
import FileInput from "@/Shared/FileInput";
import CustomMultiSelect from "@/Shared/CustomMultiSelect";
import SelectInput from "@/Shared/SelectInput";
import networkIds from "@/Assets/networkIds";

const MerchantForm = ({data, errors, setData, categories}) => {
  return (
    <div className='flex flex-wrap p-8 -mb-8 -mr-6'>
      <TextInput
        className="w-full pb-8 pr-6 lg:w-1/2"
        label="Merchant Name"
        name="merchant_name"
        type="text"
        errors={errors.merchant_name}
        value={data.merchant_name}
        onChange={e => setData('merchant_name', e.target.value)}
      />
      <TextInput
        className="w-full pb-8 pr-6 lg:w-1/2"
        label="Homepage Display URL"
        name="homepage_url"
        hint="https://www.example.com"
        type="text"
        errors={errors.homepage_url}
        value={data.homepage_url}
        onChange={e => setData('homepage_url', e.target.value)}
      />
      <TextInput
        className="w-full pb-8 pr-6 lg:w-1/2"
        label="Affiliate Homepage URL"
        hint="https://www.example.com"
        name="merchant_link_url"
        type="text"
        errors={errors.merchant_link_url}
        value={data.merchant_link_url}
        onChange={e => setData('merchant_link_url', e.target.value)}
      />
      <FileInput
        className="w-full pb-8 pr-6 lg:w-1/2"
        label="Image Logo"
        name="def_image_logo"
        accept="image/*"
        errors={errors.def_image_logo}
        value={data.def_image_logo}
        onChange={def_image_logo => setData('def_image_logo', def_image_logo)}
      />
      <TextInput
        className="w-full pb-8 pr-6 lg:w-1/2"
        label="Keywords"
        name="keywords"
        type="text"
        errors={errors.keywords}
        value={data.keywords}
        onChange={e => setData('keywords', e.target.value)}
      />

      <h2 className="w-full mb-6 font-bold">Additional Information:</h2>
      <TextInput
        className="w-full pb-8 pr-6 lg:w-1/2"
        label="Sort Name"
        name="merchant_sort_name"
        type="text"
        errors={errors.merchant_sort_name}
        value={data.merchant_sort_name}
        onChange={e => setData('merchant_sort_name', e.target.value)}
      />
      <TextInput
        className="w-full pb-8 pr-6 lg:w-1/2"
        label="Text Link Name"
        name="merchant_text_linkname"
        type="text"
        errors={errors.merchant_text_linkname}
        value={data.merchant_text_linkname}
        onChange={e => setData('merchant_text_linkname', e.target.value)}
      />
      <TextInput
        className="w-full pb-8 pr-6 lg:w-1/2"
        label="Relative URL"
        name="relative_uri"
        type="text"
        errors={errors.relative_uri}
        value={data.relative_uri}
        onChange={e => setData('relative_uri', e.target.value)}
      />
      <CustomMultiSelect
        className="w-full pb-8 pr-6 lg:w-1/2"
        label="Categories"
        errors={errors.category_id}
        setData={setData}
        mainValues={data.category_id}
        propName="category_id"
        options={categories}
      />
      <SelectInput
        className="w-full pb-8 pr-6 lg:w-1/2"
        label="Network ID"
        name="intNetworkID"
        errors={errors.intNetworkID}
        value={data.intNetworkID}
        onChange={e => setData('intNetworkID', e.target.value)}
      >
        {networkIds.map(({value, label}) => (
          <option key={value} value={value}>
            {label}
          </option>
        ))}
      </SelectInput>
      <TextInput
        className="w-full pb-8 pr-6 lg:w-1/2"
        label="Advertiser ID"
        name="intAdvertiserID"
        type="number"
        errors={errors.intAdvertiserID}
        value={data.intAdvertiserID}
        onChange={e => setData('intAdvertiserID', e.target.value)}
      />
      <TextInput
        className="w-full pb-8 pr-6 lg:w-1/2"
        label="Coupon Name"
        name="txtCouponName"
        type="text"
        errors={errors.txtCouponName}
        value={data.txtCouponName}
        onChange={e => setData('txtCouponName', e.target.value)}
      />
      <TextInput
        className="w-full pb-8 pr-6 lg:w-1/2"
        label="Coupon Place"
        name="txtCouponPlace"
        type="text"
        errors={errors.txtCouponPlace}
        value={data.txtCouponPlace}
        onChange={e => setData('txtCouponPlace', e.target.value)}
      />
      <TextInput
        className="w-full pb-8 pr-6 lg:w-1/2"
        label="Internal Notes"
        name="internal_notes"
        type="text"
        errors={errors.internal_notes}
        value={data.internal_notes}
        onChange={e => setData('internal_notes', e.target.value)}
      />
      <TextArea
        className="w-full pb-8 pr-6"
        label="Short description"
        name="short_description"
        errors={errors.short_description}
        value={data.short_description}
        onChange={e => setData('short_description', e.target.value)}
      />
      <TextArea
        className="w-full pb-8 pr-6"
        label="Long description"
        name="description"
        errors={errors.description}
        value={data.description}
        onChange={e => setData('description', e.target.value)}
      />
      <CustomCheckbox
        className="w-full pb-8 pr-6"
        label="Show Online"
        name="showonline"
        errors={errors.showonline}
        checked={data.showonline}
        onChange={e => setData('showonline', !!e.target.checked)}
      />
      {/*TODO Hyi yogo znae*/}
      {/*intNetworkID*/}
      {/*intAdvertiserID*/}
    </div>
  );
};

export default MerchantForm;
